<template>
    <v-container>
        <v-layout>
            <v-flex xs12>
                <PreviousOrders
                    title="Previous Orders"
                    :search="search"
                    :manualSearch="true"
                ></PreviousOrders>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import PreviousOrders from "./PreviousOrders.vue";

export default {
    components: {
        PreviousOrders
    },
    props: [
        
    ],
    data() {
        return {
            search: {
                stages: [3]
            }
        };
    },
    computed: {
        
    },
    methods: {
        loadPublicHolidays() {
            this.$store.dispatch("publicHolidayStore/loadPublicHolidays");
        },
        loadStores() {
            this.$store.dispatch("storeStore/loadStores");
        },
        loadSuppliers() {
            this.$store.dispatch("supplierStore/loadSuppliers");
        }
    },
    created(){
        this.loadPublicHolidays();
        this.loadStores();
        this.loadSuppliers();
    }
};
</script>

<style>
    
</style>